const guiColors = {
    'motion-primary': '#ff4c4c',
    'motion-primary-transparent': '#ff4c4ce6',
    'motion-tertiary': '#cc3333',

    'looks-secondary': '#ff4c4c',
    'looks-transparent': '#ff4d4d59',
    'looks-light-transparent': '#ff4d4d26',
    'looks-secondary-dark': 'hsla(0, 42%, 51%, 1)',

    'extensions-primary': 'hsla(10, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(10, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(10, 85%, 65%, 0.35)',
    'extensions-light': 'hsla(10, 57%, 85%, 1)',

    'drop-highlight': '#ff8c8c',

    // eslint-disable-next-line max-len
    'menu-bar-background-image': 'linear-gradient(90deg, rgba(255, 0, 0, 0.75) 0%, rgba(255, 154, 0, 0.75) 10%, rgba(208, 222, 33, 0.75) 20%, rgba(79, 220, 74, 0.75) 30%, rgba(63, 218, 216, 0.75) 40%, rgba(47, 201, 226, 0.75) 50%, rgba(28, 127, 238, 0.75) 60%, rgba(95, 21, 242, 0.75) 70%, rgba(186, 12, 248, 0.75) 80%, rgba(251, 7, 217, 0.75) 90%, rgba(255, 0, 0, 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: '#ff4c4c',
    checkboxActiveBorder: '#cc3333'
};

export {
    guiColors,
    blockColors
};
